import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showAddReport: false,
  showEditReport: {
    show: false,
    reportIndex: -1,
  },
};

const popupAddReportSlice = createSlice({
  name: "addReport",
  initialState,
  reducers: {
    openPopup: (state) => {
      state.showAddReport = true;
    },
    closePopup: (state) => {
      state.showAddReport = false;
    },
    openEdit: (state, action) => {
      state.showEditReport = action.payload;
    },
    closeEdit: (state, action) => {
      state.showEditReport = action.payload;
    },
  },
});

export const { openPopup, closePopup, openEdit, closeEdit } =
  popupAddReportSlice.actions;

export default popupAddReportSlice.reducer;
